module.exports = __webpack_public_path__ + "static/media/icon-php.82faa04c.svg";